import { Injectable } from '@angular/core';
import {JsonLogAction} from '@app/modules/shared/data/constants';
import {Observable} from 'rxjs';
import {ClassroomStateModel} from '@app/state/classroom-state.service';
import * as RoomState from '@app/state/classroom-state.service';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class JsonLogService {
  private classroom: ClassroomStateModel;

  constructor(private http: HttpClient, private store: Store) {
    this.store.select(RoomState.ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }
  public writeJsonLogs(action: JsonLogAction, payload: any): Observable<any> {
    const data = {action, data: JSON.stringify(payload)};
    return this.send(`${this.classroom.vcrURL}/classroom/write-json-logs`, data);
  }
  private send(destination: string, data: object, options?: object,): Observable<object> {
    return this.http.post(destination, data, options);
  }

}
